export const SearchColoredIcon = () => (
  <svg
    width="21"
    height="20"
    viewBox="0 0 21 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="type=search">
      <path
        id="Vector"
        d="M13.6407 12.0702H12.9199L12.6642 11.8234C13.6662 10.6558 14.1767 9.14536 14.0888 7.60928C14.0009 6.0732 13.3212 4.63092 12.1926 3.58523C11.064 2.53954 9.57412 1.97175 8.0358 2.00108C6.49749 2.03041 5.03036 2.65456 3.94241 3.74252C2.85445 4.83047 2.2303 6.2976 2.20097 7.83591C2.17164 9.37423 2.73943 10.8641 3.78512 11.9927C4.83081 13.1213 6.27309 13.801 7.80917 13.8889C9.34525 13.9768 10.8557 13.4663 12.0233 12.4644L12.2701 12.72V13.4408L16.8382 18L18.1999 16.6383L13.6407 12.0702ZM8.16009 12.0702C7.3467 12.0706 6.55149 11.8297 5.87503 11.378C5.19858 10.9263 4.67129 10.2842 4.35985 9.53276C4.04842 8.78135 3.96685 7.95446 4.12544 7.15669C4.28404 6.35891 4.67569 5.6261 5.25084 5.05095C5.82599 4.4758 6.5588 4.08415 7.35658 3.92555C8.15435 3.76696 8.98124 3.84853 9.73265 4.15996C10.4841 4.4714 11.1262 4.99869 11.5779 5.67514C12.0296 6.35159 12.2705 7.14681 12.2701 7.9602C12.2708 8.50013 12.165 9.0349 11.9587 9.53386C11.7524 10.0328 11.4497 10.4862 11.0679 10.868C10.6861 11.2498 10.2327 11.5525 9.73375 11.7588C9.23479 11.9651 8.70002 12.0709 8.16009 12.0702Z"
        fill="url(#paint0_linear_25545_63648)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_25545_63648"
        x1="4"
        y1="4"
        x2="17.5"
        y2="17.5"
        gradientUnits="userSpaceOnUse"
      >
        <stop
          offset="0.600962"
          stopColor="#F0F0F0"
        />
        <stop
          offset="0.601062"
          stopColor="#E9790C"
        />
      </linearGradient>
    </defs>
  </svg>
);
